import React from "react"
import { Flex, Text, Link } from "@chakra-ui/react"
import Icon from "./elements/Icon"

type Props = {
  attachmentFileName?: string | null
  showUnsubscribe?: boolean
}

const EmailFooter = ({ attachmentFileName, showUnsubscribe }: Props) => {
  if (!attachmentFileName && !showUnsubscribe) {
    return null
  }

  return (
    <Flex flexDirection="column" mt={5} gap={4}>
      {attachmentFileName && (
      <Flex alignItems="center" justifyContent="center">
        <Icon icon="form-attachment" size={8} />
        <Text fontSize="lg">{attachmentFileName}</Text>
      </Flex>
      )}
      {showUnsubscribe && (
      <Text align="center" color="gray.600" fontSize="sm">
        Don&apos;t want to receive invitations from us? <Link textDecoration="underline" href="#">Unsubscribe</Link>.
      </Text>
      )}
    </Flex>
  )
}

export default EmailFooter
